import { QRFC } from "./QRFC";

export class QNotifySupportRFC extends QRFC {
  constructor() {
    super();
  }

  InitRFC(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  SetParams(org, user, issue, type, priority) {
    this.AddParameter("issue", issue);
    this.AddParameter("org", org);
    this.AddParameter("priority", priority);
    this.AddParameter("type", type);
    this.AddParameter("user", user);
  }

  GetCallName() {
    return "qsupportreq";
  }

  DoTransactionComplete(response, callBackObj) {
    var r = response;
    var success = true;
    //if (r == 'failure')
    //	success = false;

    //callBackObj.ExcelXMLResult(success, r);
  }
}
